{
  "notifications": {
    "errors": {
      "delete_failed": "Failed to delete shipping method \"{name}\"."
    },
    "success": {
      "delete_succeeded": "Shipping method \"{name}\" successfully deleted."
    }
  }
}
